import { useQuery } from "@tanstack/react-query";
import { supabase } from "../../lib/supabase";
import { queryKeys } from "../../lib/queryKeys";

// "Added by", inside an opened Task only (CONTEXT.md's Author). The caller
// decides `enabled` — only worth asking when the Task's List is shared and
// the Author isn't the viewer, since that's the only time the answer would
// ever be shown. Null means either the Author's account is gone
// (ADR-0002 — the client renders "a former member") or the caller can't
// access the task at all.
export async function fetchTaskAuthorEmail(taskId: string): Promise<string | null> {
  const { data, error } = await supabase.rpc("task_author_email", { p_task_id: taskId });
  if (error) throw error;
  return (data as string | null) ?? null;
}

export function useTaskAuthorEmail(taskId: string | null | undefined, enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.taskAuthorEmail(taskId ?? ""),
    queryFn: () => fetchTaskAuthorEmail(taskId as string),
    enabled: enabled && !!taskId,
  });
}
